import { mat4, vec3 } from 'gl-matrix';
import { Grid } from '~/engine/data/common/Grid';

export interface WorldSpaceAABB {
    worldMin: vec3;
    worldMax: vec3;
}

/**
 * Compute the world-space axis-aligned bounding box of a grid by
 * transforming all 8 voxel-space corners through voxelToWorld.
 */
export function computeGridAABB(grid: Grid): WorldSpaceAABB {
    const T = grid.voxelToWorld as mat4;
    const voxel = vec3.create();
    const world = vec3.create();
    const worldMin = vec3.fromValues(+Infinity, +Infinity, +Infinity);
    const worldMax = vec3.fromValues(-Infinity, -Infinity, -Infinity);

    for (let ix = 0; ix <= 1; ix++) {
        for (let iy = 0; iy <= 1; iy++) {
            for (let iz = 0; iz <= 1; iz++) {
                voxel[0] = ix ? grid.sizeX : 0;
                voxel[1] = iy ? grid.sizeY : 0;
                voxel[2] = iz ? grid.sizeZ : 0;
                vec3.transformMat4(world, voxel, T);
                worldMin[0] = Math.min(worldMin[0], world[0]);
                worldMin[1] = Math.min(worldMin[1], world[1]);
                worldMin[2] = Math.min(worldMin[2], world[2]);
                worldMax[0] = Math.max(worldMax[0], world[0]);
                worldMax[1] = Math.max(worldMax[1], world[1]);
                worldMax[2] = Math.max(worldMax[2], world[2]);
            }
        }
    }
    return { worldMin, worldMax };
}
